import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchGePcsList } from '@/services/account';

/**
 * 获取大使列表数据
 * - ge_list 所属购物村大使
 * - pcs_list 所属导购大使
 * - sa_list 购物村大使和导购大使(邀请成为奕尚使用)
 */
const useGePcsList = () => {
  const { gePcsList, setGePcsList } = useReadyInfo();

  const { run: getGePcsList, data, loading } = useRequest(fetchGePcsList, { manual: true });

  useEffect(() => {
    if (!gePcsList || !gePcsList?.ge_list || !gePcsList?.pcs_list || !gePcsList?.sa_list) {
      getGePcsList().then((res) => {
        const ge_list =
          res?.ge_list?.map((ge) => {
            return {
              label: ge.realname,
              value: ge.id,
            };
          }) ?? [];
        const pcs_list =
          res?.pcs_list?.map((pcs) => {
            return {
              label: pcs.realname,
              value: pcs.id,
            };
          }) ?? [];
        const sa_list =
          res?.sa_list?.map((pcs) => {
            return {
              label: pcs.realname,
              value: pcs.id,
            };
          }) ?? [];
        setGePcsList({
          ge_list,
          pcs_list,
          sa_list,
        });
      });
    }
  }, [gePcsList]);

  return {
    data: gePcsList || {
      ge_list:
        data?.ge_list?.map((ge) => {
          return {
            label: ge.realname,
            value: ge.id,
          };
        }) ?? [],
      pcs_list:
        data?.pcs_list?.map((pcs) => {
          return {
            label: pcs.realname,
            value: pcs.id,
          };
        }) ?? [],
      sa_list:
        data?.sa_list?.map((pcs) => {
          return {
            label: pcs.realname,
            value: pcs.id,
          };
        }) ?? [],
    },
    loading,
  };
};

export default useGePcsList;
